import React, { Fragment } from "react";
import TheBurningGlassHeaderSection from "../components/TheBurningGlassHeaderSection";
import Head from "../components/Head";
import { META } from "../utils/constants";
import { ContentWrapper } from "../style/shared";

/* stylelint-enable */

export default ({ data }) => {
  const { clients, events, mentions, articles } = data;

  return (
    <ContentWrapper>
      <Head {...META.profile} image={META.common.image} />
      <TheBurningGlassHeaderSection content={() => <Fragment></Fragment>} />
    </ContentWrapper>
  );
};

export const windermereQuery = graphql`
  query theburningglassQuery {
    clients: allClientsJson {
      edges {
        client: node {
          name
          url
        }
      }
    }
    events: allEventsJson {
      edges {
        event: node {
          year
          position
          company
        }
      }
    }
    mentions: allMentionsJson {
      edges {
        mention: node {
          name
          url
        }
      }
    }
    articles: allArticlesJson {
      edges {
        article: node {
          name
          url
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/the-burning-glass.js